import { useCallback, useReducer } from 'react';
import { AuthReducer } from './AuthReducer';
import { AuthContext } from './AuthContext';
import { UPDATE_TOKEN, UPDATE_RECAPTCHA, UPDATE_MAIL, UPDATE_PHONE, UPDATE_ALERT_SIGNIN } from '../types';


export const TokenState = (props) => {

    const initialState = {
        token: "",
        isValidReCaptcha: false,
        mail: "",
        phone: "",
        alertSignIn: {
            message: "",
            show: false,
            title: ""
        }
    }

    const [state, dispatch] = useReducer(AuthReducer, initialState);

    const getToken = () => {
    };

    const updateToken = (token) => {
        dispatch({
            type: UPDATE_TOKEN,
            payload: token
        })
    }

    const updateCaptcha = useCallback((isValidReCaptcha) => {
        dispatch({
            type: UPDATE_RECAPTCHA,
            payload: isValidReCaptcha
        })
    }, [])

    const updatePhone = useCallback((phone) => {
        dispatch({
            type: UPDATE_PHONE,
            payload: phone
        })
    }, [])

    const updateMail = useCallback((mail) => {
        dispatch({
            type: UPDATE_MAIL,
            payload: mail
        })
    }, [])

    const updateAlertSignIn = (data) => {
        dispatch({
            type: UPDATE_ALERT_SIGNIN,
            payload: data
        })
    }

    return (

        <AuthContext.Provider value={
            {
                token: state.token,
                isValidReCaptcha: state.isValidReCaptcha,
                mail: state.mail,
                phone: state.phone,
                alertSignIn: state.alertSignIn,
                getToken,
                updateToken,
                updateCaptcha,
                updateMail,
                updatePhone,
                updateAlertSignIn
            }}>
            {props.children}
        </AuthContext.Provider>
    )

}


